import {
  Card,
  CardContent,
  Typography,
  Box,
  CardActionArea,
  styled,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import LogoImg from "assets/images/logoFrexco.png";
import PageLoader from "components/PageLoad";
import { usePopup } from "hooks/usePopup";
import React, { useEffect, useState } from "react";
import { FaWarehouse } from "react-icons/fa";
import { useHistory } from "react-router-dom";

import { setDistributionCenterId } from "../../../services/api";
import distributionCenterService from "../../../services/distributionCenterService";
const CardButton = styled(CardActionArea)({
  "&:hover": {
    backgroundColor: "#f0f0f0"
  }
});

const CardDistributionCenter = ({ center, onSelectCenter }) => {
  const theme = useTheme();

  return (
    <Card
      style={{
        marginTop: "1rem",
        boxShadow: "none",
        border: `1px solid #9f9f9f`,
        borderRadius: "0.5rem"
      }}
    >
      <CardButton onClick={() => onSelectCenter(center.id)}>
        <CardContent
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.6rem",
            padding: "0.6rem 0.8rem"
          }}
        >
          <Box
            style={{
              backgroundColor: theme.palette.primary.main,
              padding: "0.5rem",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center"
            }}
          >
            <FaWarehouse color="#fff" />
          </Box>

          <Typography style={{ color: "#525252", fontWeight: "500" }}>
            {center.name}
          </Typography>
        </CardContent>
      </CardButton>
    </Card>
  );
};

const DistributionCenterSelection = () => {
  const { addPopup } = usePopup();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [centers, setCenters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const handleSelectCenter = centerId => {
    setDistributionCenterId(centerId);
    history.push("/app");
  };

  useEffect(() => {
    const loadCenters = async () => {
      try {
        const data =
          await distributionCenterService.getDistributionCenterByUser();
        setCenters(data);

        if (data && data.length === 1) {
          handleSelectCenter(data[0].id);
        }
      } catch (error) {
        addPopup({
          type: "error",
          title: "Erro ao carregar centros de distribuição"
        });
      } finally {
        setIsLoading(false);
      }
    };
    loadCenters();
  }, []);

  if (isLoading) {
    return (
      <Box height="100vh">
        <PageLoader />
      </Box>
    );
  }

  return (
    <Box
      style={{
        display: "flex",
        width: "100%",
        height: "100vh"
      }}
    >
      {!isMobile && (
        <Box
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Box component="img" src={LogoImg} alt="Frexco" />
        </Box>
      )}

      <Box
        style={{
          flex: 1,
          background: "#ffffff",
          height: "100%",
          padding: "6rem 2rem 0",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {isMobile && (
          <Box
            component="img"
            src={LogoImg}
            alt="Frexco"
            style={{ margin: "0 auto 3rem", maxWidth: "200px" }}
          />
        )}

        <Box
          style={{
            maxWidth: "33rem",
            width: "100%",
            margin: isMobile ? "0 auto 0" : "10rem auto 0"
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            style={{
              fontSize: isMobile ? "1rem" : "1.2rem",
              fontWeight: "500"
            }}
          >
            Selecione um Centro de Distribuição
          </Typography>

          {centers.map(center => (
            <CardDistributionCenter
              key={center.id}
              center={center}
              onSelectCenter={handleSelectCenter}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DistributionCenterSelection;
